import DialpadIcon from '@material-ui/icons/Dialpad';
import FixedOddsCreate from "./FixedOddsCreate";
import FixedOddsEdit from './FixedOddsEdit';
import FixedOddsList from './FixedOddsList';

export default {
    list: FixedOddsList,
    create: FixedOddsCreate,
    edit: FixedOddsEdit,
    icon: DialpadIcon
}